export const tr = {
    'error-text': 'Sayfa yüklenemedi, tekrar deneyin',
    'error-text-header': 'Yükleme hatası'
};
